module.exports = __webpack_public_path__ + "assets/logo-white.bea2c3b4.svg";